'use strict';

import Base from './Base';
import 'core-js/fn/array/from';
import 'core-js/fn/object/assign';
import 'core-js/fn/reflect/enumerate';

import {setReadOnly} from './helpers';

var ooobject = {

  create(root, options){

    if(!root.className){
      root.className = '';
    }

    var root = Object.assign(Base(), root);

    var readonly = [];
    var init = true;

    var components = [];

    if(options){

      components = options.components || [];

      if(options.init === false){
        init = false;
      }

      readonly = options.readonly || [];

    }

    root.__inner = {};
    root.__inner.readonly = readonly;

    if(components.length > 0){
      for(var i = 0; i < components.length; i++){
        var component = components[i]({}, false);
        options.readonly = options.readonly.concat(component.__inner.readonly);
        root = Object.assign(component, root);
      }
    }

    if(init){
      if(readonly && readonly.length > 0){
        setReadOnly.call(root.__inner, 'readonly');
      }
      return root.init(options);
    }else{
      return root;
    }

  }

};

export default ooobject;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/index.js
 **/